module.exports = __webpack_public_path__ + "img/cf.4b0d23ab.svg";